import React from 'react'
import { Modal } from 'react-bootstrap'
import i18next from 'i18next'

import Notificator from './Notificator'

export default class WopiInvitationError extends React.Component {
  render() {
    const { error, onDismissError } = this.props

    return (
      error && (
        <Modal show={true}>
          <Modal.Body style={{ backgroundColor: '#F3DFF1', borderRadius: 6 }}>
            <Notificator type="error">
              <h1>{i18next.t('oops')}</h1>

              <p>{i18next.t('something_went_wrong_invitation')}</p>

              <br />

              <pre style={{ backgroundColor: 'rgba(255, 255, 255, 0.4)' }}>
                {error['status'] && (
                  <span>
                    {error['status']}: {error['statusText']}
                  </span>
                )}
              </pre>

              <br />

              <p>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    onDismissError()
                  }}
                >
                  {i18next.t('dismiss_invitation_error')}
                </a>
              </p>
            </Notificator>
          </Modal.Body>
        </Modal>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiInvitationError.js